import React from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";

function Footer(props) {
  return (
    <div>
      <p className="footer">
        Copyright © 2020 Anywhere Fitness. All rights reserved.{" "}
      </p>
    </div>
  );
}

export default Footer;
